module.exports = __webpack_public_path__ + "img/dvogados-es.svg";